import React, { useState, useEffect, useCallback } from 'react';
import './Gallery.css';
import { galleryCategories } from '../data/schoolData';

// ── HOW TO ADD YOUR PHOTOS ────────────────────────────────────
//
// 1. Copy your image files into:  src/assets/images/
//    (e.g. yoga-day.jpg, sports-meet.jpg, janmashtami.jpg ...)
//
// 2. Import them below, then add to the `galleryItems` array.
//
// 3. Each item needs:
//    { src, caption, category }
//    category: 'cultural' | 'sports' | 'nature' | 'academic'
//
// ─────────────────────────────────────────────────────────────

// import imgGate  from '../assets/images/gate.jpg';
// import imgWide  from '../assets/images/building-wide.jpg';
// import imgFront from '../assets/images/building-front.jpg';
import imgWide from '../assets/images/schoolgate.jpeg';
import imgGate from '../assets/images/schoolground.jpeg';
import imgFront from '../assets/images/playgate.jpeg';

// ← Add more imports here as you add photos
import yogaDay      from '../assets/images/yogaday.jpeg';
import yogaDay1      from '../assets/images/yoga.jpeg';
import janmashtami  from '../assets/images/krishnajanmastami.jpeg';
import treePlant    from '../assets/images/outing.jpeg';
import studentProject    from '../assets/images/studentproject.jpeg';

import openday    from '../assets/images/openday.jpeg';


const galleryItems = [
  { src: imgWide,  caption: '🏫 School Building',      category: 'academic'  },
  { src: imgGate,  caption: '📍 Main Entrance Gate',   category: 'academic'  },
  { src: imgFront, caption: '🌟 Campus Front View',    category: 'academic'  },
  // ← Add your photos below:
  { src: yogaDay,     caption: '🧘 International Yoga Day',    category: 'sports'   },
  { src: yogaDay1,     caption: '🧘 Yoga Session',    category: 'sports'   },
  { src: janmashtami, caption: '🎭 Krishna Janmashtami',       category: 'cultural' },
  { src: treePlant,   caption: '🌱 Tree Plantation Drive',     category: 'nature'   },
  { src: studentProject,   caption: '📚 Student Project Showcase',     category: 'academic'   },
  { src: openday,   caption: '🎉 Open Day',     category: 'cultural'   },
];

export default function Gallery() {
  const [active, setActive] = useState('all');
  const [lb, setLb] = useState(null); // lightbox index

  const filtered = active === 'all' ? galleryItems : galleryItems.filter(i => i.category === active);

  const openLb = (i) => setLb(i);
  const closeLb = () => setLb(null);
  const prev = useCallback(() => setLb(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);
  const next = useCallback(() => setLb(i => (i + 1) % filtered.length), [filtered.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (lb === null) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lb, prev, next]);

  return (
    <section className="section gallery-section" id="gallery">
      <div className="container">
        <div className="section-head center reveal">
          <span className="stag">Campus Life</span>
          <h2 className="stitle">Photo Gallery</h2>
          <div className="sline center" />
        </div>

        {/* Filter tabs */}
        <div className="gallery-tabs">
          {galleryCategories.map(c => (
            <button
              key={c.key}
              className={`tab-btn ${active === c.key ? 'active' : ''}`}
              onClick={() => setActive(c.key)}
            >
              {c.label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="gallery-grid">
          {filtered.length === 0 ? (
            <div className="gallery-empty">No photos available in this category yet.</div>
          ) : filtered.map((item, i) => (
            <div key={i} className="gal-item" onClick={() => openLb(i)}>
              <img src={item.src} alt={item.caption} loading="lazy" />
              <div className="gal-overlay">
                <span>{item.caption}</span>
                <div className="gal-zoom">🔍</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lb !== null && (
        <div className="lightbox" onClick={closeLb}>
          <button className="lb-close" onClick={closeLb}>✕</button>
          <button className="lb-nav lb-prev" onClick={e => { e.stopPropagation(); prev(); }}>‹</button>
          <img
            className="lb-img"
            src={filtered[lb].src}
            alt={filtered[lb].caption}
            onClick={e => e.stopPropagation()}
          />
          <button className="lb-nav lb-next" onClick={e => { e.stopPropagation(); next(); }}>›</button>
          <div className="lb-caption">{filtered[lb].caption}</div>
        </div>
      )}
    </section>
  );
}
